export const fetchData = async (path, abortController) => {
    const response = await fetch(path, {
        signal: abortController?.signal,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
    });
    return await response.json();
};
